// One-time migration for the public-id release.
//
// `tournated:platformId` and `tournated:organizationId` used to hold the numeric
// primary-key ids of the selected platform / organization. They now hold the
// string public ids. A stale numeric value would be sent verbatim to the
// `available/:id` REST endpoints — at best a wasted 404→fallback round-trip, at
// worst a mismatch with a real public id — so we clear it before any provider
// reads it.
//
// The check is type-based rather than flag-based: a JSON value that parses to a
// `number` is unambiguously the legacy format (new ids are always strings), so
// this is self-targeting and idempotent. It never clobbers a freshly written
// public id and needs no migration-version bookkeeping key.

const LEGACY_NUMERIC_SCOPE_KEYS = ["tournated:platformId", "tournated:organizationId"];

export const migrateLegacyScopeIds = () => {
  if (typeof window === "undefined") return;

  for (const key of LEGACY_NUMERIC_SCOPE_KEYS) {
    const raw = window.localStorage.getItem(key);
    if (raw === null) continue;

    try {
      if (typeof JSON.parse(raw) === "number") {
        window.localStorage.removeItem(key);
      }
    } catch {
      // Unparseable value — not a legacy numeric id; leave it for the provider
      // to deal with (it falls back to me/available on any unusable stored id).
    }
  }
};
